import { Popover } from 'antd';
import { Copy, IconProps } from 'react-feather';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import './style.less';

interface Props {
  redirect?: string;
  iconProps?: IconProps;
  disabled?: boolean;
}

const CopyIcon: React.FC<Props> = ({ redirect, iconProps, disabled }) => {
  const intl = useIntl();

  const icon = (
    <Copy
      size={20}
      cursor={'pointer'}
      {...iconProps}
      onClick={!disabled ? iconProps?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
      }}
    />
  );

  return (
    <Popover
      content={intl.formatMessage({
        id: 'commons.list.action.button.replicate',
      })}
      className="replicate-icon"
    >
      {redirect && !disabled ? <Link to={redirect}>{icon}</Link> : icon}
    </Popover>
  );
};

export default CopyIcon;
